import React from "react";
import HACK1 from "../../assets/hack1.jpeg";
import HACK2 from "../../assets/hack2.jpeg";
import HACK3 from "../../assets/hack3.jpeg";
import HACK4 from "../../assets/hack4.jpeg";
import HACK5 from "../../assets/hack5.jpeg";

// import Swiper core and required modules
import { Autoplay, Keyboard, Lazy, Pagination, Navigation } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./hackathons.css";

const Testimonials = () => {
  const data = [
    {
      avatar: HACK2,
      name: "Vesit Hacks - Praxix 2023",
      review:
        'Elated to share my recent achievement at the "VESIT HACKS" 2023 where my team was winner among a highly talented group of participants!',
    },
    {
      avatar: HACK5,
      name: "LBS 2021-22",
      review:
        "Proud to tell that my team won first price when we were in the second year. Hardwork surely does not see whether you are in 3rd year or 2nd year😉!",
    },
    {
      avatar: HACK1,
      name: "ATS 2020-21",
      review:
        "This was Ice breaker🧊! My team won first price in this first year competition. Started college life with bang!",
    },
    {
      avatar: HACK1,
      name: "LBS 2022-23",
      review:
        "Elated to share that my team received 2nd prize in LBS competition under my leadership ",
    },
    {
      avatar: HACK3,
      name: "TSEC Hacks 2023",
      review:
        "Experience of Inter-college 24 hours hackathon is unmatchable for any fresher developer. I got to learn how teams work under deadlines.",
    },
    {
      avatar: HACK4,
      name: "Persistent Semicolons 2023",
      review:
        "Thanks to Persistent multinational company for allowing us to participate in their Global Hackathon Semicolon 2023. I got to know how office life is like🤩 in such multinational companies.",
    },
  ];

  return (
    <section id="competitions" className="card-container">
		
      <h5>Competative Mood</h5>
      <h2>Competitions</h2>

      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Autoplay, Keyboard, Lazy, Pagination, Navigation]}
        spaceBetween={40}
        slidesPerView={1}
        keyboard={{
          enabled: true,
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true, type: "progressbar" }}
        navigation={true}
      >

        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide className="competition" key={index}>
              <div className="hack_card">
                <img
                  src={avatar}
                  alt="Avatar One"
                  className="client__avatar"
                  loading="lazy"
                />
                <h5 className="client__name">{name}</h5>
                <small className="client__review">{review}</small>
              </div>
            </SwiperSlide>
          );
        })}

      </Swiper>
    </section>
  );
};

export default Testimonials;
